import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";

import { PaymentUploadedView } from "../../../../components/DirectDeposit/Transactions/PaymentUploadedView";


export interface IPaymentUploadedViewPage { }

export const PaymentUploadedViewPage: FC<IPaymentUploadedViewPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="File Details"
			breadcrumbCurrentPageName=""
			// breadcrumbLinks={[]}
			mainContents={<PaymentUploadedView />}
		/>
	);
};
